import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import EngagementDetailsScreen from '@/components/EngagementDetailsScreen';

export default function PhoneEngagementDetailsScreen() {
  const { battlePlanId, engagementId } = useLocalSearchParams<{ battlePlanId: string; engagementId: string }>();

  return (
    <EngagementDetailsScreen 
      battlePlanId={battlePlanId}
      engagementId={engagementId}
      title="Phone List"
      placeholder="Search addresses, house names, numbers, or streets..."
      wakeLockId="phone-engagement"
      isPhoneEngagement={true}
    />
  );
}